<script lang="ts" setup>
    //
    //  NOTE: To be able to open the screen/page, the legacy window.js needs to be available on the page.
    //
    //  <ChoiceScreenOpener screen="AppScreens.PatientSetup" values="{1234, PatientEntity}" model="true/false">
    //      Patient Setup
    //  </ChoiceScreenOpener>
    //
    import * as ChoiceUtils from "../lib/ChoiceUtils"
    import * as ChoiceUserConfiguration  from "../lib/ChoiceUserConfiguration"
    import * as OfficeMdUrls  from "../lib/OfficeMdUrls"
    import { IAppId, AppIDs } from "../lib/AppId";

    import { AppScreens } from '../Enums/ChoiceEnums'
    import { ref, onMounted } from "vue"


    const props = withDefaults(defineProps<{
        screen: AppScreens,     // NOTE: From cw_lookup.security_screens, this is the screen_id column
            values?: (IAppId[] | IAppId), // Can be either a single AppId or an array of them
            modal?:boolean,
            json?: any
        }>(), {
            modal: false,
    });

    const isRestricted = ref<boolean | null>(null);

    onMounted(async () =>{
        isRestricted.value = !ChoiceUserConfiguration.haveScreenAccess(props.screen);
    });

    function openScreen() {
        if (!ChoiceUtils.IsDefined(window_open))
        {
            console.warn("window_open_request is not available (did you forget to reference window.js?");
            window.alert("Unable to open window: window_open_request is not available");
            return;
        }

        const destUrl = OfficeMdUrls.AppUrl(props.screen, new AppIDs(props.values));
        try
        {
            window_open(props.screen, destUrl, props.modal, props.json);
        }
        catch(err)
        {
            alert(`Error trying to open window: ${err?.message}`);
        }
    }
</script>

<template>
    <span style="cursor:pointer" v-if="values">
        <span @click="openScreen" v-if="false === isRestricted">
            <slot></slot>
        </span>
        <span v-else>
            <slot name="restictedMsg">
                <span class="text-danger">
                    Restricted
                </span>
            </slot>
        </span>
    </span>
</template>